import { Category } from './data.class';

const getters = {
  GET_CATEGORY: (state: any) => (id: any) => {
    const cat = state.categories.find(
      (category: Category) => category.id === id
    );
    return cat ? cat : {};
  }
};

export default getters;
